import { render } from "./tutorAdd.vue?vue&type=template&id=94183720"
import script from "./tutorAdd.vue?vue&type=script&lang=js"
export * from "./tutorAdd.vue?vue&type=script&lang=js"

import "./tutorAdd.vue?vue&type=style&index=0&id=94183720&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__